import { render, staticRenderFns } from "./AllocateMachine.vue?vue&type=template&id=ee7d1aca"
import script from "./AllocateMachine.vue?vue&type=script&lang=js"
export * from "./AllocateMachine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports